import { io } from "socket.io-client";
import { ref } from "vue";
import { auth } from "./auth";

const SOCKET_URL = "https://sudarshan.fonetricks.com";

const socketRef = ref(null);
const connected = ref(false);

export function useAgentSocket() {
  function connect() {
    if (socketRef.value?.connected) return socketRef.value;

    socketRef.value = io(SOCKET_URL, {
      auth: { type: "agent", token: auth.token },
      transports: ["websocket"],
    });

    socketRef.value.on("connect", () => (connected.value = true));
    socketRef.value.on("disconnect", () => (connected.value = false));

    socketRef.value.on("connect_error", (err) => {
      console.log("socket connect_error:", err?.message || err);
    });

    return socketRef.value;
  }

  function disconnect() {
    socketRef.value?.disconnect();
    socketRef.value = null;
    connected.value = false;
  }

  return { socket: socketRef, connected, connect, disconnect };
}